import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../actions/currentOrder';

const initialState = null as string | null;

const slice = createSlice({
  name: '$deliveryNotes',
  initialState,
  reducers: {
    setDeliveryNotes(state, action: PayloadAction<string>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, (state, action) => {
      return initialState;
    });
  },
});

export const { setDeliveryNotes } = slice.actions;
export default slice.reducer;
